import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export abstract class GlobalErrorDisplayService {
  abstract display(error: HttpErrorResponse | unknown): void;
}
